/**
 * See the vocabularies objects in ./tests/responseFixture.js
 * for the country and state schema assumed here.
 * Whereas a typical country looks like:
 *   '283': 'United States',
 * a typical state looks like:
 *   '4781': 'Alaska - AK - United States',
 * This module filters the latter state items by a selected country.
 */
const filterStatesByCountry = (countryValue = '283', country, state, delimiter = ' - ') => {
  const countryName = country[countryValue];
  const newState = {};

  Object.keys(state).forEach((key) => {
    const item = state[key].split(delimiter);

    if (item.indexOf(countryName) === 2) {
      newState[key] = item.splice(0, 2).join(delimiter);
    }
  });

  return newState;
};

export default filterStatesByCountry;
